import type { ReactNode } from 'react';
import { cn } from '@shared/utils';
import type { UserResponse } from '@shared/api/rest/users';
import { ProfileResponse } from '@shared/api/rest/profile/models';

interface IUserInfo {
  className?: string;
  value?: ProfileResponse | UserResponse;
  children?: ReactNode;
}

export const UserInfo = (props: IUserInfo) => {
  if (!props.value) return null;
  return (
    <div
      className={cn(
        'w-full',
        props.value.locked && [
          'relative flex items-center justify-center p-4',
          'before:absolute before:left-0 before:z-[40] before:h-full before:w-full before:rounded-sm before:bg-white before:opacity-50',
        ],
        props.className,
      )}
    >
      <div className='w-full'>{props.children}</div>
    </div>
  );
};
